import type {
  IEquityPerpCreateRequest,
  IEquityPerpCreateResponse,
} from "@pulse-ui/codegen-v2/generated_ts/refdata";
import { api } from "../base";

export type { IEquityPerpCreateRequest, IEquityPerpCreateResponse };

const equityPerpsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Lists a CLST spot market sourced from a BINF/HYPL equity perpetual. */
    listEquityPerp: build.mutation<IEquityPerpCreateResponse, IEquityPerpCreateRequest>({
      query: (body) => ({
        url: "/api/trading-ops/v1/equity-perps",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RefdataInstruments", "RefdataAssets"],
    }),
  }),
});

export const { useListEquityPerpMutation } = equityPerpsEndpoints;
